"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface WaveDropAuthorPfpProps {
  readonly drop: ApiDrop;
}
const WaveDropAuthorPfp: React.FC<WaveDropAuthorPfpProps> = t0 => {
  const $ = _c(16);
  const {
    drop
  } = t0;
  const isFirstPlace = drop.author.winner_main_stage_drop_ids && drop.author.winner_main_stage_drop_ids.length > 0;
  const shadowClass = isFirstPlace ? "tw-shadow-[0_1px_4px_rgba(251,191,36,0.15)]" : "";
  let t1;
  if ($[0] !== drop.author.pfp) {
    t1 = drop.author.pfp ? resolveIpfsUrlSync(drop.author.pfp) : null;
    $[0] = drop.author.pfp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resolvedPfp = t1;
  const authorHandle = drop.author.handle;
  const profileHref = authorHandle ? `/${authorHandle}` : null;
  const tooltipUser = authorHandle ?? drop.author.id;
  const containerClasses = `tw-relative tw-flex-shrink-0 tw-h-12 tw-w-12 tw-rounded-lg tw-bg-iron-900 tw-overflow-hidden ${shadowClass}`;
  let t2;
  if ($[2] !== authorHandle || $[3] !== resolvedPfp) {
    t2 = resolvedPfp ? <Image src={resolvedPfp} alt={authorHandle ? `${authorHandle}'s profile picture` : "Profile picture"} fill={true} sizes="48px" className="tw-object-contain tw-rounded-lg tw-bg-transparent" /> : <div className="tw-h-full tw-w-full tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10 tw-rounded-lg" />;
    $[2] = authorHandle;
    $[3] = resolvedPfp;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const avatarContent = t2;
  const handleClick = _temp;
  if (!profileHref) {
    let t3;
    if ($[5] !== avatarContent || $[6] !== containerClasses) {
      t3 = <div className={containerClasses}>{avatarContent}</div>;
      $[5] = avatarContent;
      $[6] = containerClasses;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  const t3 = `View ${tooltipUser}'s profile`;
  const t4 = `${containerClasses} tw-block`;
  let t5;
  if ($[8] !== avatarContent || $[9] !== profileHref || $[10] !== t3 || $[11] !== t4) {
    t5 = <Link href={profileHref} prefetch={false} aria-label={t3} onClick={handleClick} className={t4}>{avatarContent}</Link>;
    $[8] = avatarContent;
    $[9] = profileHref;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5 || $[14] !== tooltipUser) {
    t6 = <UserProfileTooltipWrapper user={tooltipUser}>{t5}</UserProfileTooltipWrapper>;
    $[13] = t5;
    $[14] = tooltipUser;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default WaveDropAuthorPfp;
function _temp(event) {
  event.stopPropagation();
}